<template>
  <business-phone-number />
</template>
<script>
import BusinessPhoneNumber from './components/BusinessPhoneNumber.vue';
export default {
  components: {
    BusinessPhoneNumber
  }
}
</script>